import { ReactComponent as LeftArrow } from "assets/icons/back-arrow.svg";
import { ExtraPaddingProps } from "components/PopupsFullPageContainer";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

export const Container = styled.div<ExtraPaddingProps>`
  margin-top: 30px;
  margin-left: 50px;
  transition: padding-top
    ${({ extraPaddingTopAnimationDuration }) =>
      extraPaddingTopAnimationDuration}s;
  padding-top: ${({ extraPaddingTop }) => extraPaddingTop}px;

  @media (max-width: ${breakpoints.sm}) {
    margin-left: 20px;
  }
`;

export const StyledLink = styled(Link)`
  display: inline-flex;
  align-items: center;

  > span {
    @media (max-width: ${breakpoints.sm}) {
      display: none;
    }
  }
`;

export const StyledLeftArrow = styled(LeftArrow)`
  height: 12px;
  margin-right: 10px;
  fill: ${({ theme }) => theme.colors.dark};
`;
